
<div :class="flipped ? 'flip-container flipped': 'flip-container'" class="h-100" >
    <div class="flipper h-100">
        <div class="front h-100 " :style="frontStyle">
            <slot name="front"></slot>
            <div style="position: absolute; top: 3px; right: 34px; color: white" v-if="backText">{{ backText }}</div>
            <v-icon
                class="frontFlipBtn"
                :style="style"
                :class="color"
                v-on:click="onFlip(true)"
                v-if="enabled"
                style="z-index: 1"
            >
               {{ frontIcon }}
            </v-icon>
        </div>
        <div class="back h-100 ">
            <slot name="back"></slot>
            <div style="position: absolute; top: 3px; right: 34px; color: white" v-if="frontText">{{ frontText }}</div>
            <v-icon
                class="backFlipBtn"
                :style="style"
                :class="color"
                v-on:click="onFlip(false)"
                style="z-index: 1"
            >
                {{ backIcon }}
            </v-icon>
        </div>
    </div>
</div>
